import React, { useCallback, useEffect, useState } from "react";
import SomaForm from "../../../components/SomaStandard/SomaForm";
import Dropdown from "../../../components/SomaStandard/FormComponents/Dropdown";
import { toast } from "react-toastify";
import SomaPlaceService from "../../../Services/SomaPlace/index";
import { parseCep, parseCNPJ, parseCPF, parsePhoneNumber } from "../util/parsers";
import { validarCNPJ, validateCPF, validateNumber } from "../util/validators";
import ESTADOS_DATA from "../RowData/estados";
import BANCOS_DATA, { TIPO_CONTA_DATA } from "../RowData/bancos";
import useUser from "../../../Hooks/UserContext";
import { Typography } from "@material-ui/core";

const FormSomaPlaceCadastro = (props) => {
  
  const [state, setState] = useState({
    state: "",
    clifor: null,
    accountType: "",
    bankNumber: "",
    ...props.state,
    ...props.edit,
 
  });

  useEffect(()=>{
    setState({
      state: "",
      clifor: null,
      accountType: "",
      bankNumber: "",
      ...props.state,
      ...props.edit,
    
    })
  },[props.edit, props.state])

  const [lockedFields, setLockedFields] = useState({ ...props.lockedFields });
  if (setLockedFields) {
  }
  const user = useUser();

  const setUserSomaplaceData = useCallback(async () => {
    const res = await SomaPlaceService.SomaPlace.fetchInfo();
    const bankData = await SomaPlaceService.SomaPlace.fetchBanckDataUser(res.data.user);

    res.data.user.bankData = bankData.data;
    let somaPlaceUser = res.data.user;
    setState({
      ...state,
      id: somaPlaceUser.id,
      clifor: somaPlaceUser.clifor,
      corporateName: somaPlaceUser.corporateName,
      street: somaPlaceUser.street,
      complement: somaPlaceUser.complement,
      primaryPhone: parsePhoneNumber(somaPlaceUser.primaryPhone),
      number: somaPlaceUser.number,
      district: somaPlaceUser.district,
      representativeEmail: somaPlaceUser.representativeEmail,
      representativeDocumentNumber: parseCPF(somaPlaceUser.representativeDocumentNumber),
      city: somaPlaceUser.city,
      state: somaPlaceUser.state,
      zipCode: somaPlaceUser.zipCode,
      representativeName: somaPlaceUser.representativeName,
      professionalQualification: somaPlaceUser.professionalQualification,
      cnpj: parseCNPJ(somaPlaceUser.cnpj),
      stateRegistration: somaPlaceUser.stateRegistration,
      tradeName: somaPlaceUser.tradeName,
      bankId: somaPlaceUser.bankData?.id,
      bankUserId: somaPlaceUser.bankData?.userId,
      bankNumber: somaPlaceUser.bankData?.bankNumber,
      accountNumber: somaPlaceUser.bankData?.accountNumber,
      agencyNumber: somaPlaceUser.bankData?.agencyNumber,
      accountType: somaPlaceUser.bankData?.accountType,
      accountDigit: somaPlaceUser.bankData?.accountDigit,
    });
  }, [state]);

  useEffect(() => {
    if (state.contratoAccept && state.id_profiles !== state.contratoAccept.id_profiles) {
      setState({ ...state, contratoAccept: undefined });
    }
    if (user && state.clifor === null) {
      setState({ ...state, clifor: user.clifor });
    }
    if (Object.keys(state).length === 0) {
      setUserSomaplaceData();
    }
  }, [setUserSomaplaceData, state, user]);

  const BANCOS_DATA_MAPPED = BANCOS_DATA.map((v, i) => {
    return { value: v.value, text: v.value + " - " + v.label };
  });

  let CepLookupEvent = 0;
  const cepLookup = async (cep) => {
    const ans = await fetch(`http://viacep.com.br/ws/${cep}/json/`).then((r) => r.json());

    setState({
      ...state,
      city: ans.localidade,
      state: ans.uf,
      zipCode: parseCep(cep),
      district: ans.bairro,
      logradouro: ans.logradouro,
    });
  };
  
  const Opts = {
    state: [state, setState],
    setResults: (result) =>
      new Promise(async (resolve, reject) => {
        result.primaryPhone = result.primaryPhone.replace(/[- ] */g, "");
        result.cnpj = result.cnpj.replace(/[./-]*/g, "");
        result.representativeDocumentNumber = result.representativeDocumentNumber.replace(/[.-]*/g, "");
        try {
          let updateResult;          
          result.id = state.id;
          updateResult = await SomaPlaceService.SomaPlace.updateSomaPlaceUser(result);
          
          let bankData = {
            id: state.bankId,
            userId: updateResult.data.id,
            bankNumber: result.bankNumber + "",
            accountNumber: result.accountNumber + "",
            agencyNumber: result.agencyNumber + "",
            accountType: result.accountType + "",
            accountDigit: result.accountDigit + "",
          };

          toast.success("Usuário Cadastrado com sucesso!");
          try {
            if (state.bankId === undefined) {
              await SomaPlaceService.SomaPlace.registerBankData(bankData);
            } else {
              await SomaPlaceService.SomaPlace.updateBankData(bankData);
            }
            toast.success("Dados Bancários cadastrados com sucesso!");
          } catch (error) {
            toast.error("Erro ao inserir os dados bancários, tente novamente!");
          }
          setTimeout(() => props.setSomaPlaceUser(updateResult.data).then(() => resolve()), 1000);
        } catch (error) {
          toast.error(error.message);
          reject();
        }
      }),
    disable: lockedFields,
    columns: [
      {
        component: () => {
          return (
            <Typography noWrap style={{ color: "#707070", fontSize: "20px", fontFamily: "flama-medium" }}>
              Dados da Empresa
            </Typography>
          );
        },
        size: 12,
      },
      {
        propText: "Nome Fantasia*",
        propName: "tradeName",
        validate: [{ test: (e) => e, message: "Obrigatório" }],
      },
      {
        propText: "Razão Social*",
        propName: "corporateName",
        validate: [{ test: (e) => e, message: "Obrigatório" }],
      },
      {
        propText: "CNPJ*",
        propName: "cnpj",
        parse: (cnpj) => {
          return parseCNPJ(cnpj);
        },
        validate: [
          { test: (e) => e, message: "Obrigatório" },
          { test: validarCNPJ, message: "CNPJ inválido" },
        ],
      },
      {
        propText: "IE*",
        propName: "stateRegistration",
        validate: [
          { test: (e) => e, message: "Obrigatório" },
          { test: validateNumber, message: "O valor deve ser númerico" },
        ],
      },
      {
        component: () => {
          return (
            <Typography noWrap style={{ color: "#707070", fontSize: "20px", fontFamily: "flama-medium" }}>
              Endereço
            </Typography>
          );
        },
        size: 12,
      },
      {
        propText: "CEP*",
        propName: "zipCode",
        parse: (v) => {
          if (v.match(/\d/g)?.length === 8) {
            clearTimeout(CepLookupEvent);
            CepLookupEvent = setTimeout(() => cepLookup(v.match(/\d/g).join("")), 300);
          }
          return parseCep(v);
        },
        validate: [{ test: (e) => e, message: "Obrigatório" }],
      },
      {
        propText: "Estado*",
        propName: "state",
        component: Dropdown,
        componentProps: {
          options: ESTADOS_DATA,
        },
        validate: [{ test: (e) => e, message: "Obrigatório" }],
      },
      {
        propText: "Cidade*",
        propName: "city",
        validate: [{ test: (e) => e, message: "Obrigatório" }],
      },
      {
        propText: "Bairro*",
        propName: "district",
        validate: [{ test: (e) => e, message: "Obrigatório" }],
      },
      {
        propText: "Logradouro(Endereço)*",
        propName: "street",
        validate: [{ test: (e) => e, message: "Obrigatório" }],
      },
      {
        propText: "Número*",
        propName: "number",
        validate: [
          { test: (e) => e, message: "Obrigatório" },
          { test: validateNumber, message: "O valor deve ser númerico" },
        ],
      },
      {
        propText: "Complemento*",
        propName: "complement",
        validate: [{ test: (e) => e, message: "Obrigatório" }],
      },
      {
        propText: "Telefone*",
        propName: "primaryPhone",
        parse: (phone) => {
          return parsePhoneNumber(phone);
        },
        validate: [
          { test: (e) => e, message: "Obrigatório" },
          { test: validateNumber, message: "O valor deve ser númerico" },
        ],
      },
      {
        component: () => {
          return (
            <Typography noWrap style={{ color: "#707070", fontSize: "18px", fontFamily: "flama-medium" }}>
              Dados do Responsável
            </Typography>
          );
        },
        size: 12,
      },
      {
        propText: "Nome Responsável*",
        propName: "representativeName",
        validate: [
          { test: (e) => e, message: "Obrigatório" },
          { test: (e) => e?.split(" ").length >= 2, message: "Nome e Sobrenome" },
        ],
      },
      {
        propText: "Qualificação Profissional*",
        propName: "professionalQualification",
        validate: [{ test: (e) => e, message: "Obrigatório" }],
      },
      {
        propText: "Email*",
        propName: "representativeEmail",
        validate: [
          { test: (e) => e, message: "Obrigatório" },
          { test: (e) => e?.split("@").length >= 2, message: "Email inválido" },
        ],
      },
      {
        propText: "CPF*",
        propName: "representativeDocumentNumber",
        parse: (cpf) => {
          return parseCPF(cpf);
        },
        validate: [
          { test: (e) => e, message: "Obrigatório" },
          { test: validateCPF, message: "CPF inválido" },
        ],
      },
      {
        component: () => {
          return (
            <Typography noWrap style={{ color: "#707070", fontSize: "18px", fontFamily: "flama-medium" }}>
              Dados Bancários
            </Typography>
          );
        },
        size: 12,
      },
      {
        propText: "Bancos*",
        propName: "bankNumber",
        component: Dropdown,
        componentProps: {
          options: BANCOS_DATA_MAPPED,
        },
        size: 4,
        validate: [{ test: (e) => e, message: "Obrigatório" }],
      },
      {
        propText: "Agencia*",
        propName: "agencyNumber",
        size: 4,
        validate: [{ test: (e) => e, message: "Obrigatório" }],
      },
      {
        propText: "Conta*",
        propName: "accountNumber",
        validate: [
          { test: (e) => e, message: "Obrigatório" },
          { test: validateNumber, message: "O valor deve ser númerico" },
        ],
        size: 4,
      },
      {
        propText: "Digito*",
        propName: "accountDigit",
        size: 2,
        validate: [
          { test: (e) => e, message: "Obrigatório" },
          { test: validateNumber, message: "O valor deve ser númerico" },
        ],
      },
      {
        propText: "Tipo da Conta*",
        propName: "accountType",
        component: Dropdown,
        componentProps: {
          options: TIPO_CONTA_DATA,
        },
        size: 4,
        validate: [{ test: (e) => e, message: "Obrigatório" }],
      },
    ],
  };

  return (
    <>
      <SomaForm {...Opts} />
    </>
  );
};

export default FormSomaPlaceCadastro;
